<template>
  <div class="basicEmployeeDetails">
    <!-- Tab content area -->
    <div class="c-common-space c-responsive-fixwidth c-common-box-shadow c-radius3">
        <div class="c-user-tab-content clearfix">
            <div class="col-md-6 table-td-border-right">

                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">{{ $t('nick_name') }}:</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(employeeData && employeeData.employable && employeeData.employable.display_name!="" && employeeData.employable.display_name!=null)? employeeData.employable.display_name : ""}}</p>
                    </div>
                </div>

                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">{{ $t('seniority') }}:</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(employeeData.seniority) ? getRoundOffSkillSeniority(employeeData.seniority) : 0}}</p>
                    </div>
                </div>

                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                       <h4 class="h4">{{ $t('shift_count') }}:</h4>
                    </div>
                    <div class="col-md-7">
                       <p class="h5-v1">{{(employeeData.total_shifts!="")?employeeData.total_shifts: 0}}</p>
                    </div>
                </div>

                <div v-for="(add,index) in (employeeData.employable)?employeeData.employable.addresses:[]" :key="index" class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                       <h4 class="h4">{{ $t('address')}}  {{ $t(add.label) }}:</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{add.address+", "+add.municipality+", "+ add.postcode+", "+add.state_province+", "+add.country}}</p>
                    </div>
                </div>
                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">{{ $t('primary_email') }}</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(employeeData.employable) ? employeeData.employable.email : ''}}</p>
                    </div>
                </div>         
                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">{{ $t('secondary_email')}}</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(employeeData.employable && employeeData.employable.secondary_email!="") ? employeeData.employable.secondary_email : ''}}</p>
                    </div>
                </div>
                
            </div>
            <div class="col-md-6">
                
                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">{{ $t('status') }}</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(employeeData.employee_status)? employeeData.employee_status.name:"NA"}}</p>
                    </div>
                </div>
                <div v-for="(phno,index) in (employeeData.employable)?employeeData.employable.phones:[]" :key="index" class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">{{ $t(phno.label) }}</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">
                            <!-- {{phno&&phno.phone_number?phno.phone_number:"Not Provided"}} -->
                            <a :href="'tel:'+getClientContactFormat(phno.phone_number)" class="phone-number-display">
                                {{ phno.phone_number ? getClientContactFormat(phno.phone_number) : '' }}
                            </a>
                        </p>
                    </div>
                </div>

                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">{{ $t('member_since') }}</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(employeeData.member_since!=null)?getDate(employeeData.member_since) : "NA"}}</p>
                    </div>
                </div>
                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">{{ $t('date_of_hire') }}</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{(employeeData.date_of_hire!=null)?getDate(employeeData.date_of_hire) : "NA"}}</p>
                    </div>
                </div>

                <div v-if="custom_field1.name!=''" class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">{{custom_field1.name}}</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{custom_field1.value}}</p>
                    </div>
                </div>
                <div v-if="custom_field2.name!=''" class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">{{custom_field2.name}}</h4>
                    </div>
                    <div class="col-md-7">
                        <p class="h5-v1">{{custom_field2.value}}</p>
                    </div>
                </div>
                

                <div class="col-sm-12 o-no-padding">
                    <div class="col-md-5">
                        <h4 class="h4">{{ $t('locals') }}</h4>
                    </div>
                   
                </div>

            </div>
        </div>
    </div>

    <div class="c-common-space c-responsive-fixwidth mt-15 c-common-box-shadow c-radius3">
        <div class="c-user-tab-content1 clearfix">
            <p class="content-title">
                {{ $t('emergency_card') }}:                                   
                <span class="disclaimer-note">
                    The information provided to Emergency Contact Data is owned by you and will be voluntarily shared by CallSteward, LLC to the relevant Administrative, Power Users, and  Stewards, within the CallSteward system, in the regular execution of their duties.<br />
                    DO NOT SHARE ANY information that you feel violates your privacy.<br />
                    This information is collected to expedite communication on your behalf in a health emergency.
                </span>
            </p>
            <div class="content-body row">
                <div class="col-md-6 table-td-border-right">
                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                            <h4 class="h4">Contact Name:</h4>
                        </div>
                        <div class="col-md-7">
                            <p class="h5-v1">{{ employeeData.emergency_contact&&employeeData.emergency_contact.length&&employeeData.emergency_contact[0].contact_name?employeeData.emergency_contact[0].contact_name:'' }}</p>
                        </div>
                    </div>
                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                            <h4 class="h4">Home Phone:</h4>
                        </div>
                        <div class="col-md-7">
                            <p class="h5-v1">{{ employeeData.emergency_contact&&employeeData.emergency_contact.length&&employeeData.emergency_contact[0].home_phone_no?employeeData.emergency_contact[0].home_phone_no:'' }}</p>
                        </div>
                    </div>

                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                        <h4 class="h4">Medical Conditions of Note:</h4>
                        </div>
                        <div class="col-md-7">
                        <p class="h5-v1">{{ employeeData.emergency_contact&&employeeData.emergency_contact.length&&employeeData.emergency_contact[0].medical_conditions_note?employeeData.emergency_contact[0].medical_conditions_note:'' }}</p>
                        </div>
                    </div>                    
                </div>
                <div class="col-md-6">                
                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                            <h4 class="h4">Contact Number</h4>
                        </div>
                        <div class="col-md-7">
                            <p class="h5-v1">{{ employeeData.emergency_contact&&employeeData.emergency_contact.length&&employeeData.emergency_contact[0].contact_number?employeeData.emergency_contact[0].contact_number:'' }}</p>
                        </div>
                    </div>
                    
                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                            <h4 class="h4">Cell Phone</h4>
                        </div>
                        <div class="col-md-7">
                            <p class="h5-v1">{{ employeeData.emergency_contact&&employeeData.emergency_contact.length&&employeeData.emergency_contact[0].cell_phone_no?employeeData.emergency_contact[0].cell_phone_no:'' }}</p>
                        </div>
                    </div>
                    <div class="col-sm-12 o-no-padding">
                        <div class="col-md-5">
                            <h4 class="h4">Regular Medications</h4>
                        </div>
                        <div class="col-md-7">
                            <p class="h5-v1">{{ employeeData.emergency_contact&&employeeData.emergency_contact.length&&employeeData.emergency_contact[0].regular_medications?employeeData.emergency_contact[0].regular_medications:'' }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /Tab content area -->

    <!-- <div class="c-common-space">
        <div class="c-user-tab-content u-pad-top-10 clearfix">
            <div class="col-md-4">
                <div class="col-md-5">
                    <p>User Name</p>
                </div>
                <div class="col-md-7">
                    <p><span>{{this.display_name}}</span></p>
                </div>
                <div class="col-md-5">
                    <p>Seniority</p>
                </div>
                <div class="col-md-7">
                    <p><span>{{this.employeeData.seniority}}</span></p>
                </div>
                <div class="col-md-5">
                    <p>Shift Count</p>
                </div>
                <div class="col-md-7">
                    <p><span>0</span></p>
                </div>
                <div v-for="address in this.employable.addressess">
                  <div class="col-md-5" >
                      <p>{{capitalizedFirst(address.label)}} Address</p>
                  </div>
                  <div class="col-md-7">
                      <p><span>{{address.address}}</span> </p>
                  </div>
              </div>

            </div>
            <div class="col-md-4">
                    <div class="col-md-5">
                        <p>Email</p>
                    </div>
                    <div class="col-md-7">
                        <p><span>{{this.employable.email}}</span> </p>
                    </div>

                    <div class="col-md-5">
                        <p>Member since</p>
                    </div>
                    <div class="col-md-7">
                        <p><span>{{this.member_since[0]}}</span></p>
                    </div>
                    <div class="col-md-5">
                        <p>Status</p>
                    </div>
                    <div class="col-md-7">
                        <p><span>130 south 7th Street</span> </p>
                    </div>
                    <div class="col-md-5">
                        <p>Locals</p>
                    </div>
                    <div class="col-md-7">
                        <p><span>dev</span></p>
                    </div>
                </div>
        </div>
    </div> -->
  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services';
    import dateTimeConvert from '../../timeConvert&Compare';
    export default {
        computed: {
            ...mapGetters({
                currentEmployeeID: 'currentEmployeeID',
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: 'userClientID'
            }),
        },
        data() {
            return {
                employeeData: {},
                custom_field1:{},
                custom_field2:{}
            }
        },
        props: {
            empDetails: {
                type: Object,
                required: true
            }
        },
        watch: {
            empDetails: function(newData) {
                //console.log(newData);
                this.employeeData = newData;
                if(newData && newData.custom_field1)
                    this.custom_field1=JSON.parse(newData.custom_field1);
                if(newData && newData.custom_field2)
                    this.custom_field2=JSON.parse(newData.custom_field2);
                
            }
        },
        methods: {
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                phone = phone.replace(/-/g, "");
                phone = phone.replace(/ /g, "");
                phone = phone.replace("(", "");
                phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) { 
                    // console.log(phone);
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    // console.log(phone);
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
                // return phone;
            },
            getRoundOffSkillSeniority(seniorityVal) {     
                // console.log(seniorityVal); 
                if(seniorityVal && seniorityVal != '') {          
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },
            getDate(dateTime) {
                return dateTimeConvert.localDate(dateTime);
            },
            capitalizedFirst(str) {
                var lower = str.toLowerCase();
                return lower.replace(/(^| )(\w)/g, function(x) {
                    return x.toUpperCase();
                });
            }
        },
        created() {
            this.employeeData = this.empDetails;
            // console.log()
            if(this.empDetails && this.empDetails.custom_field1)
                this.custom_field1=JSON.parse(this.empDetails.custom_field1);
            if(this.empDetails && this.empDetails.custom_field2)
            this.custom_field2=JSON.parse(this.empDetails.custom_field2);
        }
    }

</script>

<style scoped>

.mt-15 {
    margin-top: 30px;
}

.c-user-tab-content1{
    padding: 0;
    border: 3px solid #F67801;
    background-color: #ffffff;
}

.c-user-tab-content1 .content-title{
    padding: 15px;
    /* text-align: center; */
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    background-color: #f67801;
    color: #ffffff;
}

.c-user-tab-content1 .content-body{
    padding: 15px 20px 20px;
}

.disclaimer-note {
    margin-left: 5px;
    margin-top: 5px;
    font-weight: 400;
    font-size: 15px;
    /* padding-bottom: 5px; */
    line-height: 20px;
}
.phone-number-display{
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
}

</style>
